import {ALead} from "../../services/types.generated"
import {createSimpleContext, createStateContext} from "../../utils/context.tsx"
import {TLeadsFiltering} from "./useLeadsFiltering.ts"

export const DeletingContext = createStateContext<ALead | number[] | null>("deleting")
export const EditingContext = createStateContext<ALead | null>("editing")

export const LeadsFilteringContext = createSimpleContext<TLeadsFiltering>("filtering")
